import { render } from "./RuleEditHistoryView.vue?vue&type=template&id=808eafa0"
import script from "./RuleEditHistoryView.vue?vue&type=script&lang=js"
export * from "./RuleEditHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleEditHistoryView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "808eafa0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('808eafa0', __exports__)) {
    api.reload('808eafa0', __exports__)
  }
  
  module.hot.accept("./RuleEditHistoryView.vue?vue&type=template&id=808eafa0", () => {
    api.rerender('808eafa0', render)
  })

}


export default __exports__